class ElementStyle {
  static readonly wall_color_default = 0x003eff;
  static readonly wall_color_checked = 0xf00;
  static readonly wall_line_width = 3;
  static readonly wall_line_dash = 0;
  static readonly virtual_wall_line_width = 4;
  static readonly access_line_width = 20;

  static readonly func_area_color_default_bg = "#f70825";
  static readonly func_area_color_checked_line = "rgba(247, 8, 37, 1)";
  static readonly func_area_line_width = 3;

  static readonly transparent_color = "rgba(250, 250, 250, 0.0)";
  static readonly edit_area_color = "rgba(51, 57, 74, 0.4)";

  static readonly noise_area_color_default_bg_1 = "rgba(219, 237, 255, 1.0)";
  static readonly noise_area_color_default_bg_2 = "rgba(139, 170, 200, 1.0)";

  static readonly area_outline_color_checked = "#f00";
  static readonly area_line_color = "#000";
  static readonly area_line_width = 3;

  static readonly func_point_angle_line_width = 3;
  static readonly func_point_angle_line_color = "#f00";

  static readonly vehicle_track_line_color_1 = "rgba(42, 48, 62, 0.8)";
  static readonly vehicle_track_line_width_1 = 8;
  static readonly vehicle_track_line_color_2 = "rgba(197, 205, 222, 0.8)";
  static readonly vehicle_track_line_width_2 = 20;
  static readonly vehicle_track_line_color_1_wg = "#2a303e";
  static readonly vehicle_track_line_color_2_wg = "#c5cdde";

  static readonly line_index_color = "#ffffff";

  static readonly point_text_color = "#333333";

  static readonly point_text_font_size = 20;

  static readonly text_color_333333 = "#333333";

  static readonly default_text_height = 26;

  static readonly path_line_width = 4;
  static readonly path_line_dash = 5;
  static readonly path_line_color = "#c1c6d1";
  static readonly gridding_line_color = "#cccccc";
  static readonly gridding_line_width = 1;

  static readonly index_hint_font_size = 15; //路线序号字体大小
  static readonly car_width = 16; //mark车量清扫区域宽80cm

  static readonly will_clean_task_line_width = 16; //待清洗
  static readonly cleaned_task_line_width_path = 20; //已清洗
  static readonly will_clean_task_line_color = "rgba(255, 255, 218, 0.8)";

  static readonly cleaned_task_line_width = 2.1; //已清洗
  static readonly cleaned_task_line_color = "rgba(68, 211, 122, 1)";

  static readonly miss_point_line_width = 2.1; //漏清洗
  static readonly miss_point_line_color = "rgba(255, 115, 132, 1)";

  static readonly wait_point_line_width = 2.1; //待清洗
  static readonly wait_point_line_color = "rgba(255, 255, 218, 0.8)";

  static readonly obstacle_point_width = 1;
  static readonly obstacle_cell_point_color = "rgba(139, 170, 200, 1.0)"; //障碍物点信息
  static readonly obstacle_point_color = "rgba(139, 170, 200, 1.0)"; //栅格点信息

  static readonly anchor_line_width = 1;
  static readonly anchor_line_color = "#F70825"; //锚点连线
  static readonly anchor_line_dash = 5; //锚点连线

  static readonly hand_fill_color = "rgba(51, 57, 74, 0.4)"; //手绘填充区域颜色
  static readonly hand_fill_color_hex = "#33394a"; //手绘填充区域颜色

  static readonly default_text_size = 20; //默认画布字体大小

  static readonly transparent_line_width = 30;
  static readonly blind_road_color_default = "#ffdc00";
  static readonly wall_color_checked_number = 0xff0000;

  static readonly zindex_noise_area = 0;
  static readonly zindex_fun_area = 1;
  static readonly zindex_virtual_wall_line = 2;

  static readonly wall_color_default_rgba = "rgba(0, 62, 255, 1)";
  static readonly wall_color_checked_rgba = "rgba(240, 0, 0, 1)";
  static readonly func_area_color = "rgba(247, 8, 37, 0.3)";

  static readonly map_extent_pixel = 5; //5里面代表一个像素
}

export default ElementStyle;
